import { Component, OnInit } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {environment} from '../../../../environments/environment'

@Component({
  selector: 'app-base-ui-container',
  templateUrl: './base-ui-container.component.html',
  styleUrls: ['./base-ui-container.component.scss']
})
export class BaseUIContainerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  baseURL = "environment.serverContext"
  flixie = this.baseURL + "assets/css/flexie/flexie.css"
  zorro = this.baseURL + "assets/css/flexie/flexie.css"
  uibase = this.baseURL + "assets/css/flexie/flexie.css"

  env = environment;

}
